import React, { memo, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import Paper from '@material-ui/core/Paper';
import IntroductionContainer from '../../containers/IntroductionContainer';
import StepperHeaderContainer from '../../containers/StepperHeaderContainer';
import StepTitleContainer from '../../containers/StepTitleContainer';
import StepDescriptionContainer from '../../containers/StepDescriptionContainer';
import StepNavigatorContainer from '../../containers/StepNavigatorContainer';
import GeneralContainer from '../../containers/GeneralContainer';
import NetworkingContainer from '../../containers/NetworkingContainer';
import UsersContainer from '../../containers/UsersContainer';
import TrunksContainer from '../../containers/TrunksContainer';
import Summary from '../Summary/Summary';
import QRContainer from '../../containers/QRContainer';
import LicenceContainer from '../../containers/LicenceContainer';
import LogoutButtonContainer from '../../../auth/containers/LogoutButtonContainer';
import styles from './wizard.module.scss';

import OverrideSetupDialog from '../OverrideSetupDialog/OverrideSetupDialog';

const conditionalStyles = classNames.bind(styles);

export default memo(function Wizard(props) {
    const [openWarningDialog, setOpenWarningDialog] = useState(props.hasSetup);

    useEffect(() => {
        return () => {
            if (props.hasSetup) {
                props.changeStep(1);
            }
        };
    }, []);

    const closeDialog = () => setOpenWarningDialog(false);

    return (
        <div className={styles.container}>
            {openWarningDialog && <OverrideSetupDialog closeDialog={closeDialog} open={openWarningDialog} />}
            <StepperHeaderContainer />
            {
                props.activeStep === 1 &&
                <div className={styles.introductionContainer}>
                    <Paper className={styles.introductionContent}>
                        <IntroductionContainer />
                    </Paper>
                </div>
            }
            {
                props.activeStep !== 1 &&
                <div className={styles.stepContainer}>
                    <Paper className={styles.descriptionContainer}>
                        <StepTitleContainer />
                        <StepDescriptionContainer />
                    </Paper>
                    <Paper className={styles.formWrapper}>
                        <div
                            className={conditionalStyles({
                                formContainer: true,
                                smallContainer: props.activeStep === 5 || props.activeStep === 6
                            })}
                        >
                            {(() => {
                                switch (props.activeStep) {
                                    case 2:
                                        return <GeneralContainer />;
                                    case 3:
                                        return <NetworkingContainer />;
                                    case 4:
                                        return <UsersContainer />;
                                    case 5:
                                        return <TrunksContainer />;
                                    case 6:
                                        return <Summary />;
                                    case 7:
                                        return <QRContainer />;
                                    case 8:
                                        return <LicenceContainer />;
                                    default:
                                        return null;
                                }
                            })()}
                        </div>
                        <div className={styles.navigatorContainer}>
                            {
                                (
                                    !props.isLastStep &&
                                    (!props.isQRActiveStep ||
                                        (props.isQRActiveStep && !props.isCompleting))
                                ) &&
                                <StepNavigatorContainer />
                            }
                            {
                                (props.isQRActiveStep || props.isLastStep) &&
                                !props.error &&
                                !props.isCompleting &&
                                <LogoutButtonContainer />
                            }
                        </div>
                    </Paper>
                </div>
            }
        </div>
    );
});
